var Component = require('../../Component');
var utils = require('../../../global/utils');
var isEmpty = utils.isEmpty;
var draggable = require('../../../global/draggable');

var FloatController = function (options) {
    (function (self) {
        var defaults = {
          active: false,
          index_base: 1000,
          index_z: 1000,
          u_key: 0
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
      self._children = {};
      self.view_count = 0;
      self.top_u_key = null;
    })(this);
};
FloatController.prototype = Object.create(Component.prototype);
FloatController.prototype.bound = function (ele) {
  if(ele && ele.length){
    this._element = ele;
    this._options.active = true;
  }
};
FloatController.prototype.render = function () {

};
FloatController.prototype.getView = function (view_key) {
  if(!this._options.active)return;
  if (view_key && !isEmpty(this._children[view_key])) {
    return this._children[view_key]
  }
  return null;
};
FloatController.prototype.addView = function (view, position) {
  if(!this._options.active)return;
  var self = this;
  if(isEmpty(view._options._u_key))view._options._u_key = self._options.u_key + 1;
  self._options.index_z += 1;
  view.index_z = self._options.index_z;
  self._children[view._options._u_key] = view;
  self._children[view._options._u_key].addEventListener('click', function (item) {
    if(isEmpty(item))return;
  });
  self._children[view._options._u_key].addEventListener('close', function (item) {
    if(isEmpty(item))return;
    var u_key = item.u_key;
    if(self._children[u_key]){
      self.removeView(self._children[u_key]);
    }
  });
  self._children[view._options._u_key].addEventListener('setTop', function (item) {
    if(isEmpty(item))return;
    var u_key = item.u_key;
    if(self._children[u_key]){
      self.setTop(u_key);
    }
  });
  self._element.append(view.getElement());
  view.getElement().css('z-index', view.index_z);
  if(!isEmpty(view._options._parent_u_key) && !isEmpty(self._children[view._options._parent_u_key])){
    self._children[view._options._parent_u_key]._children_views[view._options._u_key] = view;
    view._options.stage = self._children[view._options._parent_u_key]._options.stage + 1;
    view._options._root_u_key = self._children[view._options._parent_u_key]._options._root_u_key;
    var parent_view_element = self._children[view._options._parent_u_key].getElement();
    if(parent_view_element.hasClass('im-draggable-content')){
      var draggable_x = parent_view_element.data('draggable-x');
      var draggable_y = parent_view_element.data('draggable-y');
      draggable_x = !isNaN(draggable_x) ? draggable_x: 0;
      draggable_y = !isNaN(draggable_y) ? draggable_y: 0;
      draggable.move(view.getElement(), {
        top: draggable_y + 40,
        left: draggable_x + 40
      });
    }
  } else if(!isEmpty(position) && !isEmpty(position.initTop) && !isEmpty(position.initLeft)){
    view._options.stage = 1;
    view._options._root_u_key = view._options._u_key;
    draggable.move(view.getElement(), {
      top: position.initTop,
      left: position.initLeft
    });
  }
  if (!draggable.data_set) {
    let im_app = $('.im-app'); 
    if (im_app) {
      if (im_app[0] && !isNaN(im_app[0].offsetTop * -1) && !isNaN(im_app[0].offsetLeft * -1)) {
        draggable.setData({
          edge_top: im_app[0].offsetTop * -1,
          edge_left: im_app[0].offsetLeft * -1,
          edge_bottom: im_app[0].offsetTop * -1 + im_app.height(),
          edge_right: im_app.width()
        });
      }
    }
  }
  draggable.mount(view.getElement(), {        
    document_move: true
  });
  self.view_count++;
  return view;
};
FloatController.prototype.setTop = function (u_key) {
  if(!isEmpty(this.top_u_key) && this.top_u_key === u_key)return;
  var row = [];
  var _row = [];
  var indexes = [];
  for(var view in this._children){
    if(this._children[view]){
      row.push(this._children[view]);
      indexes.push(this._children[[view]].index_z);
      if(view != u_key)_row.push(this._children[view]);
    }
  }
  _row.sort(function(front, behind){
    return front.index_z > behind.index_z ? -1 : 1;
  });
  indexes.sort(function(front, behind){
    return front > behind ? -1 : 1;
  });
  if(row.length){
    this._children[u_key].index_z = indexes.shift();
    this._children[u_key].getElement().css('z-index', this._children[u_key].index_z);
    this.top_u_key = u_key;
    for(var index=0;index<_row.length;index++){
      if(_row[index]){
        _row[index].index_z = indexes[index];
        _row[index].getElement().css('z-index', indexes[index]);
      }
    }
  }
};
FloatController.prototype.removeView = function (view) {
  if(!this._options.active)return;
  var self = this;
  for(let view_key in view._children_views) {
    if (!isEmpty(self._children[view_key])) {
      self.removeView(self._children[view_key]);
    }
  }
  view.getElement().remove();
  delete self._children[view._options._u_key];
  view = null;
  self.view_count--;
  if(self.view_count == 0)self._options.index_z = self._options.index_base;
};
FloatController.prototype.removeAll = function () {
  if(!this._options.active)return;
  for(let view_key in this._children) {
    if (!isEmpty(this._children[view_key])) {
      this.removeView(this._children[view_key]);
    }
  }
};
FloatController.prototype.hide = function () {
    if(this._options.active)this._element.hide();
};
FloatController.prototype.show = function () {
    if(this._options.active)this._element.show();
};

module.exports = FloatController;
